import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  constructor(public http: HttpClient) {}

  private header = new HttpHeaders({
    'Content-Type': 'application/json',
    'x-api-key': environment.apiKey,
  });
  public establishmentList(): Observable<any> {
    const body = {
      query: `
        query {
          listOrganizations(filter: {visibility: {eq: true}}) {
            items {
              address
              city
              company_name
              email
              id
              phone_number
              postal_code
              pronote_link
              website_url
            }
          }
        }        
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }

  public establishmentListWithTheirTraining(): Observable<any> {
    const body = {
      query: `
        query {
          listOrganizations(filter: {visibility: {eq: true}}) {
            items {
              id
              visibility
              address
              city
              company_name
              createdAt
              email
              img
              phone_number
              postal_code
              pronote_link
              website_url
              training(filter: {visibility: {eq: true}}) {
                items {
                  id
                  job_title
                }
              }
            }
          }
        }
      `,
    };
    return this.http.post(environment.baseUrl, body, { headers: this.header });
  }
}
